// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"a2c128512e7272e2602a","562":"c37489db014e51d8c04b","704":"3ffe0a543c141d81f625","812":"96bb871923ead146a953"}[chunkId] + ".chunk.js";
};